"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PetsAllowedOptions = exports.WaterFeeBasisOptions = exports.SecurityDepositOptions = exports.RentPeriodOptions = exports.HeatingOptions = exports.LaundryMachineOptions = exports.DishwasherOptions = exports.CarHeatingSocketOptions = exports.ParkingOptions = exports.SaunaOptions = exports.BuildingTypeOptions = exports.StorageOptions = exports.ConditionOptions = exports.KitchenOptions = exports.RoomOptions = exports.BalconyOptions = exports.ApartmentLanguageOptions = void 0;
exports.ApartmentLanguageOptions = {
    fi: 'fi',
    en: 'en'
};
// start of PropertyInfo properties
exports.BalconyOptions = {
    notSure: 'notSure',
    no: 'no',
    balcony: 'balcony',
    glass: 'glass',
    protruding: 'protruding',
    balconet: 'balconet'
};
exports.RoomOptions = {
    '1h': '1h',
    '2h': '2h',
    '3h': '3h',
    '4h': '4h',
    '5h': '5h',
    '+5h': '+5h'
};
exports.KitchenOptions = {
    K: 'K',
    KK: 'KK',
    KT: 'KT',
    AK: 'AK',
    TUPAK: 'TUPAK',
    other: 'other'
};
exports.ConditionOptions = {
    good: 'good',
    excellent: 'excellent',
    satisfactory: 'satisfactory'
};
exports.StorageOptions = {
    notSure: 'notSure',
    no: 'no',
    attic: 'attic',
    cage: 'cage',
    room: 'room'
};
// end of property info
// building info
exports.BuildingTypeOptions = {
    apartmentBuilding: 'apartmentBuilding',
    rowHouse: 'rowHouse',
    loft: 'loft',
    detached: 'detached',
    semiDetached: 'semiDetached'
};
// end of building info
// start of AdditionalProperties types
exports.SaunaOptions = {
    notSure: 'notSure',
    no: 'no',
    own: 'own',
    shared: 'shared'
};
exports.ParkingOptions = {
    notSure: 'notSure',
    no: 'no',
    streetParking: 'streetParking',
    ownGarage: 'ownGarage',
    sharedGarage: 'sharedGarage',
    parkingLot: 'parkingLot'
};
exports.CarHeatingSocketOptions = {
    notSure: 'notSure',
    no: 'no',
    yes: 'yes'
};
exports.DishwasherOptions = {
    notSure: 'notSure',
    no: 'no',
    installable: 'installable',
    yes: 'yes'
};
exports.LaundryMachineOptions = {
    notSure: 'notSure',
    no: 'no',
    installable: 'installable',
    yes: 'yes'
};
exports.HeatingOptions = {
    notSure: 'notSure',
    electric: 'electric',
    geothermal: 'geothermal',
    district: 'district',
    exhaustAir: 'exhaustAir',
    other: 'other'
};
// end of additional props
// ApartmentConfirmation
exports.RentPeriodOptions = {
    formerlyValid: 'formerlyValid',
    elevenMonths: 'elevenMonths',
    temporary: 'temporary',
    temporaryNegotiate: 'temporaryNegotiate'
};
exports.SecurityDepositOptions = {
    zero: 'zero',
    oneMonth: 'oneMonth',
    twoMonths: 'twoMonths',
    threeMonths: 'threeMonths',
    other: 'other'
};
exports.WaterFeeBasisOptions = {
    negotiate: 'negotiate',
    perTenant: 'perTenant',
    perApartment: 'perApartment',
    metered: 'metered',
    included: 'included'
};
exports.PetsAllowedOptions = {
    yes: 'yes',
    no: 'no',
    negotiate: 'negotiate'
};
//# sourceMappingURL=apartmentsOptions.js.map